import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-heart",
  templateUrl: "./med-icon-heart.component.html",
})
export class MedIconHeartComponent extends SvgMixinComponent {}
